<div class="dialogform-container personnel">
    <div class="v-window-header">
        <span *ngIf="dialogData.action == 'create'">Add Equipment</span>
        <span *ngIf="dialogData.action == 'edit'">Edit Equipment</span>
        <div [mat-dialog-close]="true" class="v-window-closebox">
          <mat-icon class="icon action">close</mat-icon>
        </div>
      </div>    
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <mat-card-content *ngIf="!isLoading">

        <div mat-dialog-content  [ngClass]="{'min-content': dialogData.action == 'edit'}">
            <div class="columns">
                <div class="column" *ngIf="dialogData.action == 'create'">

                    <h4>Equipment 
                        <span class="required_item"> *</span>
                    </h4>
                    <mat-form-field class="filter-type" appearance="fill" *ngIf="allEquipment" >
                        <input 
                        (blur)="checkContent('equipment')"
                        (keyup)="valueChange($event.target.value, 'equipment')"
                        [matChipInputFor]="chipListEquipment"
                        #equipmentInput
                        [formControl]="ctrlEquipment"
                        [matAutocomplete]="autoPersonnel" 
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="addElem($event, 'equipment')"/>
                        <mat-icon
                        class="select-arrow"
                        matSuffix>keyboard_arrow_down</mat-icon>
                        <mat-chip-grid 
                        required="required" 
                        #chipListEquipment aria-label="element.name">
                            <mat-chip-row
                            *ngFor="let item of selectedEquipment"
                            (removed)="removeElem(item, 'equipment')">
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                            <span *ngIf="item.serialNumber">{{item.serialNumber}} - {{item.description}} </span>
                            <span *ngIf="!item.serialNumber">{{item}}</span> 
                            </mat-chip-row>
                        </mat-chip-grid>
                        <mat-autocomplete #autoPersonnel="matAutocomplete" (optionSelected)="selectedElem($event, 'equipment')">
                            <ng-container *ngFor="let elem of allEquipment  | async" >
                                <mat-option *ngIf="!checkIfExists(elem, 'equipment')" [value]="elem">
                                    {{elem.serialNumber}}
                                <span *ngIf="elem?.description.length > 0">{{ ' - ' + elem.description}}</span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <div class="column2">
            
                    <h4>Services 
                        <span class="required_item"> *</span>
                    </h4>
                    <mat-form-field class="filter-type" appearance="fill">
                        <input 
                        (blur)="checkContent('services')"
                        (keyup)="valueChange($event.target.value, 'services')"
                        [matChipInputFor]="chipListServices"
                        #servicesInput
                        [formControl]="ctrlServices"
                        [matAutocomplete]="autoServices" 
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="addElem($event, 'services')"/>
                        <mat-icon
                        class="select-arrow"
                        matSuffix>keyboard_arrow_down</mat-icon>
                        <mat-chip-grid 
                        required="required" 
                        #chipListServices aria-label="element.name">
                            <mat-chip-row
                            *ngFor="let item of selectedServices"
                            (removed)="removeElem(item, 'services')">
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                            <span *ngIf="item?.name">{{item.name}} </span>
                            <span *ngIf="!item?.name">{{item}}</span> 
                            </mat-chip-row>
                        </mat-chip-grid>
                        <mat-autocomplete #autoServices="matAutocomplete" (optionSelected)="selectedElem($event, 'services')">
                            <ng-container *ngFor="let elem of allServices | async" >
                                <mat-option *ngIf="!checkIfExists(elem, 'services')" [value]="elem">
                                    {{elem.name}}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>


                </div>
      
            </div>
        </div>
    
        <div mat-dialog-actions>
    
        <button mat-raised-button [ngClass]="{'disabled': !validForm}" color="primary" (click)="saveChanges();">
            Save
            <mat-icon class="icon action">save</mat-icon>
        </button>
        <button mat-raised-button color="primary" (click)="closePopup()">
            Close
            <mat-icon class="icon action">close</mat-icon>
        </button>
        </div>
    </mat-card-content>
</div>
    